import { AbilityBuilder, createMongoAbility } from '@casl/ability';
import type { RawRuleOf } from '@casl/ability';
import type { CompanyDashboardAccessContext } from '@/abilities/companyDashboard/context';
import { COMPANY_DASHBOARD_DESTINATION, type CompanyDashboardAbility } from '@/abilities/companyDashboard/vocabulary';

// Rules only on the tabs; the page takes its access from them.
export const companyDashboardRules = ({
  hasVendorExpenses,
  isRestricted,
}: CompanyDashboardAccessContext): RawRuleOf<CompanyDashboardAbility>[] => {
  const { can, rules } = new AbilityBuilder<CompanyDashboardAbility>(createMongoAbility);
  if (hasVendorExpenses && !isRestricted) {
    can(['see', 'open'], COMPANY_DASHBOARD_DESTINATION, { destination: 'vendorExpenses' });
  }
  return rules;
};
